module.exports = __webpack_public_path__ + "static/media/logo_white.196af16a.svg";